import type { Route } from "@/config/models"

type RouteLike = Pick<Route, "href" | "pageTitle">

export function getNumericHttpStatus(error: unknown): number | null {
	if (!error || typeof error !== "object" || !("status" in error)) {
		return null
	}

	const status = (error as { status: unknown }).status
	return typeof status === "number" ? status : null
}

export function getCurrentBrowserHref() {
	return window.location.href
}

export function replaceBrowserUrl(nextUrl: string) {
	window.history.replaceState(window.history.state, "", nextUrl)
}

export function setBrowserDocumentTitle(title: string) {
	document.title = title
}

export function hasQueryParamValue(search: string, key: string, expectedValue: string) {
	const searchParams = new URLSearchParams(search)
	return searchParams.get(key) === expectedValue
}

export function buildUrlWithoutQueryParam(currentHref: string, key: string) {
	const currentUrl = new URL(currentHref)
	currentUrl.searchParams.delete(key)

	const nextSearch = currentUrl.searchParams.toString()
	return `${currentUrl.pathname}${nextSearch ? `?${nextSearch}` : ""}${currentUrl.hash}`
}

export function getMatchingRoute<T extends RouteLike>(pathname: string, routeMap: Record<string, T>) {
	return Object.values(routeMap).find((route) => pathname === route.href || pathname.startsWith(`${route.href}/`))
}
